<template>
  <div>
    <breadcrumbs home="Terms" :back="back"/>

    <purtrak-table name="terms" objectType="terms" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="terms2"
                   fields="id,name,active"
                   :listFilters="listFilters"
                   :item-class="term => (!term.active ? 'grey--text ' : '')"
                   @dblclick="term => $router.push({name:'SettingsTermsEdit',params:{termId:term.id}})"
                   title="Terms"
                   :print-info="{pageSize:'portrait', subTitle:[]}"
                   download-endpoint="termsExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.search='';filters.status='1'">
          <v-list-item>
            <filter-search label="Term name" v-model="filters.search"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Tax: {{filters.search}}</v-chip>
          <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'SettingsTermsEdit'}"><v-list-item-title>Create term</v-list-item-title></v-list-item>
        <template v-if="$store.getters.company.connectedToAccounting">
          <v-divider/>
          <v-list-item @click="sync()"><v-list-item-title>Sync terms with QBO</v-list-item-title></v-list-item>
        </template>
      </template>

      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SettingsTermsEdit'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn small icon @click.stop="term = item;showDelete = true"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
      <template v-slot:item.name="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <template v-else>
          <v-hover v-if="!readOnly" v-slot="{hover}">
            <a @click.stop="$router.push({name:'SettingsTermsEdit',params:{termId:item.id}})"
                :class="{'text-decoration-underline':hover,'grey--text':!item.active}">{{item.name}}</a>
          </v-hover>
          <div v-else :class="{'grey--text':!item.active}">{{item.name}}</div>
          <div v-if="!item.active" class="grey--text text-caption">Inactive</div>
        </template>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="term.name" @delete="performDeleteTerm"/>
  </div>
</template>

<script>

export default {
  name: 'SettingTerms',
  props: {
    back: {type:Array, required:false}
  },
  data() {
    return {
      filters: {
        status: '1',
        search: ''
      },
      term: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true}],
      headers: [{ text: 'TERM', value: 'name', width:'90%',sortable:true},
                { text: '' , value:'action', width:'5%', sortable:false,align:'center'}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    },
    listFilters() {
      const filters = [];
      if (this.filters.search)
        filters.push({field:'name', comparator:'contains', value:this.filters.search});
      if (this.filters.status != '2')
        filters.push({field:'active', comparator:'eq', value:this.filters.status === '1' ? 'true' : 'false'});
      return filters;
    }
  },
  methods: {
    async performDeleteTerm() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingTerms($id:ID!) {
                                                objectDelete(id:$id)
                                              }`,
                                          {id:this.term.id});
      this.loading = false;
      if (!results.error) {
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted term ${this.term.name}`});
      }
    },
    async sync() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingTerms {
                                             accountingIntegrationSync(step:"terms") {name}
                                           }`, {});
      if (!results.error) {
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Synced terms with QBO`});
      }
    }
  }
}
</script>